import React,{useContext,useEffect} from 'react'
import {HeadTableLeads, RowLeadsasignLider } from "../../ui-components";
import LeadsContext from '../../context/leads';
import moment from "moment";


function AssignLeader({onToggleTab,setAssignLead, order}) {  
  const {Leadslist, models, Subs} = useContext(LeadsContext)

  useEffect(()=>{
    Leadslist(3, order);
    Subs();
  },[order])

  const overHeadTable = {
    "Asignaci\u00F3n": {children: "Asignado a sucursal"},
    "Asesor Conekta": {children: "Asignado a Asesor"},
    Sucursal: {children: "Contact Center"},
    Descarte: {children: "Sucursal"},
    Asesor: {children: "No. de Asignación"},
    Fase: {children: "Asesor"},
    "Atenci\u00F3n": { display: "none" },
    "Acci\u00F3n": { display: "block" },
  }
  //console.log(models)
  return (
    <div className="overflow-x-scroll py-2">
    <HeadTableLeads type="asignLider" overrides={overHeadTable}/>
    {models?.map((lead, index) => (
      index % 2 == 0 ?
      <RowLeadsasignLider key={lead.id} leads={lead} overrides={{
        Estatus:{
          children:
          `${moment(lead.dateManager,"DD-MM-YYYY HH:mm").add(1, 'days').fromNow().slice(0,2) === "in" && lead.dateAtencion === null
          ? "Por Atender" : lead.dateAtencion != null ? "Atendido" : "Sin Atención"}`,
            color: `${moment(lead.dateManager,"DD-MM-YYYY HH:mm").add(1, 'days').fromNow().slice(0,2) != "in" && "red"}`
          
        },
        ButtonVer:{
          onClick: () =>{
            onToggleTab(6)
            setAssignLead(lead)
          }
        },
        ButtonAsign:{
          onClick: () =>{
            onToggleTab(7)
            setAssignLead(lead)
          }
        }
      }} /> :
      <RowLeadsasignLider key={lead.id} leads={lead} overrides={{
        "Frame 20797":{backgroundColor: "#ffffff"},
        Estatus:{children:
          `${moment(lead.dateManager,"DD-MM-YYYY HH:mm").add(1, 'days').fromNow().slice(0,2) === "in" && lead.dateAtencion === null
          ? "Por Atender" : lead.dateAtencion != null ? "Atendido" : "Sin Atención"}`,
          color: `${moment(lead.dateManager,"DD-MM-YYYY HH:mm").add(1, 'days').fromNow().slice(0,2) != "in" && "red"}`
        },
        ButtonVer:{
          onClick: () =>{
            onToggleTab(6)
            setAssignLead(lead)
          }
      },
      ButtonAsign:{
        onClick: () =>{
          onToggleTab(7)
          setAssignLead(lead)
        }
      }
      }}/> 
    ))}
  </div>

  )
}

export default AssignLeader